import React from 'react';
import {connect} from 'react-redux';
import { Field, reduxForm } from 'redux-form';

const mapState = (state) => {
    return {
    	initialValues: {
			apaterno: state.registro.apaterno,
			amaterno: state.registro.amaterno,
			nombres: state.registro.nombres
    	},
        email: state.registro.email,
        fechaNacimiento: state.registro.fechaNacimiento,
        ramo: state.registro.ramo,
        poliza: state.registro.poliza,
        certificado: state.registro.certificado,
        inicioVigenciaPoliza: state.registro.inicioVigenciaPoliza
    };
}

const espacios = tipo => (value, campos) => {
	let texto = (value != undefined && value != " ")? value : '';
	texto = texto.replace(/\s{2,}/g, ' ');
	campos[tipo] = texto;
}
const validate = values => {
    const errors = {};
  
    if (!values.nombres) {
        errors.nombres = "Campo requerido.";
    }

    if (!values.apaterno) {
        errors.apaterno = "Campo requerido.";
    }
    
    if (!values.amaterno) {
        errors.amaterno = "Campo requerido.";
    }
    
    return errors;
}
const campo = ({ input, label, type, meta: { touched, error } }) => {
    return <div className="input-wrap">
		<label htmlFor={input.name}>{label}</label>
		<span className="clearfix input-active">
				<div>
					<input {...input} type={type} maxLength="50" />
				</div>
		</span>
		{ touched && error &&
		    <div className="error-wrap">
		        <div className="msj-error">
		            <p><span>{error}</span></p>
		        </div>
			</div>
		}
	</div>
}

class CompletarForm extends React.Component {
	state = {
		ramo : "Gastos Medicos"
	}

	componentWillMount = () => {
		if(this.props.ramo ==  "G"){
			this.state.ramo = "Gastos Médicos";
		} else if(this.props.ramo ==  "D") {
			this.state.ramo = "Daños";
		} else if(this.props.ramo ==  "V") {
			this.state.ramo = "Vida";
		} else {
			this.state.ramo = "Autos";
		}
	}
	
    render() {
    	const { handleSubmit, pristine, reset, submitting } = this.props;
        return (
			<form onSubmit={handleSubmit}> 
        		<div className='text-content'>
					<div className="datos-wrap row">
						<div className="col-xs-12">
							<h3 className="mt-34">Completar tu registro</h3>
						</div>
						<div className="col-md-12 col-xs-12 mt-25">
							<div className="row mt-25">
								<div className="col-xs-12 col-md-6">
									<div className="texto-15 gray-text">
										<p>Para poder concluir tu registro es importante que nos proporciones la siguiente información:</p>
									</div>
									<div className="row mt-34">
										<div className="col-xs-12">
											<Field name="apaterno" label="Apellido Paterno" component={campo} type="input" validate={espacios('apaterno')} />
										</div>
										<div className="col-xs-12">
											<Field name="amaterno" label="Apellido Materno" component={campo} type="input" validate={espacios('amaterno')} />
										</div>
										<div className="col-xs-12">
											<Field name="nombres" label="Nombre(s)" component={campo} type="input" validate={espacios('nombres')} />
										</div>
									</div>
								</div>
								<div className="col-xs-12 col-md-6">
									<div className="texto-15 gray-text">
										<p>Agradecemos que valides tu información, si es correcta puedes continuar.</p>
									</div>
									<div className="row">
										<div className="col-md-10 col-md-offset-1 col-xs-12 mt-34">
											<div className="card">
												<ul className="list-divider">
													<li className="clearfix">
														<div>
															<p><b>Correo electrónico</b></p>
														</div>
														<div>
															<div className="gray-text texto15">
																<p style={{wordBreak: "break-all"}}>{this.props.email}</p>
															</div>
														</div>
													</li>
													<li className="clearfix">
														<div>
															<p><b>Fecha de nacimiento</b></p>
														</div>
														<div>
															<div className="gray-text texto15">
																<p>{this.props.fechaNacimiento}</p>
															</div>
														</div>
													</li>
													<li className="clearfix">
														<div>
															<p><b>Ramo</b></p>
														</div>
														<div>
															<div className="gray-text texto15">
																<p>{ this.state.ramo }</p>
															</div>
														</div>
													</li>
													<li className="clearfix">
														<div>
															<p><b>No. póliza o No. referencia</b></p>
														</div>
														<div>
															<div className="gray-text texto15">
																<p>{this.props.poliza}</p>
															</div>
														</div>
													</li>
													{this.props.certificado && <li className="clearfix">
														<div>
															<p><b>No. de certificado</b></p>
														</div>
														<div>
															<div className="gray-text texto15">
																<p>{this.props.certificado}</p>
															</div>
														</div>
													</li>}
													<li className="clearfix">
														<div>
															<p><b>Fecha inicio de vigencia de la póliza</b></p>
														</div>
														<div>
															<div className="gray-text texto15">
																<p>{this.props.inicioVigenciaPoliza}</p>
															</div>
														</div>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<button className="orange-rectangle" type="submit">Siguiente</button>
				</div> 
			</form>
		)
    }
}

CompletarForm = reduxForm({form: 'registro-asistido-completar', validate})(CompletarForm);

export default connect(mapState, null)(CompletarForm);


// WEBPACK FOOTER //
// ./src/registro-asistido/completar.frm.js